
import React from "react"
import { Button, Col, Empty, Row, Spin, Table } from "antd"
import AddMovementItemModal from "../AddMovementItemModal"
import CreateMovementModal from "../CreateMovementModal"
import { useRegister } from "../../contexts/RegisterContext"
import { useConfig } from "../../contexts/ConfigContext"
import { textNumberFormater } from "../../utils"

function RegisterView(props:any){
  const {register} = useRegister()
  const {config} = useConfig()
  const showHeaderElement = !!props.headerElement
  return (
    <div className="container-fluid">
      <Spin size="large" tip="Procesando..." fullscreen spinning={props.spinning}  />
      {props.topBanner}
      {config.isMobile && <div style={{marginBottom:"1.5rem",alignItems:"center",justifyContent:"space-between",display:"flex"}}>
        <h1 className="title-content">{props.title}</h1>
      </div>}   
      <div className="card shadow" style={{marginBottom:"1.5rem"}}>
        <div className="card-header" style={{paddingTop:"1rem"}}>
          <Row>
            <Col 
              xs={showHeaderElement ? 0 : 24} 
              sm={showHeaderElement ? 0 : 24} 
              md={8} 
              lg={8} 
              xl={8} 
              xxl={8}
            >
              <h6 className="font-weight-bold text-primary" style={{margin:0, fontSize: '1.25rem'}} >{props.title || 'Datos de registro'}</h6>
            </Col>
            <Col 
              xs={showHeaderElement ? 24 : 0} 
              sm={showHeaderElement ? 24 : 0} 
              md={{ span: 14, offset: 2 }} 
              lg={{ span: 12, offset: 4 }} 
              xl={{ span: 10, offset: 6 }} 
              xxl={{ span: 8, offset: 8 }}
            >
              { showHeaderElement && <props.headerElement/>}
            </Col>
          </Row>
        </div>
        <div className="card-body">
          <Table 
            rowClassName={"no-padding-rows"} 
            columns={props.columnsData} 
            dataSource={props.itemList}
            onRow={props.onRow}
            size="small"
            pagination={false}
            scroll={{x:"max-content"}}
            locale={{emptyText:<Empty description="Sin registros, agregue el primero"></Empty>}}
            footer={props.footerElement}></Table>
        </div>
      </div>
      <div
        style={{
          position: "sticky",
          bottom: 0,
          background: "#fff",
          padding: "16px",
          boxShadow: "0 -2px 10px rgba(0,0,0,0.1)",
          zIndex: 10,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "1rem",
          borderRadius: "8px 8px 0 0",
        }}
      >
        <Row gutter={[10, 10]}>
          <Col>
            <Button type="primary" onClick={()=>props.addPending(true)}>{props.actionButtonText || "Facturar"}</Button>
          </Col>
          <Col>
            <Button type="default" onClick={()=>props.addPending(false)}>Guardar</Button>
          </Col>
        </Row>
        <div style={{ display: "flex", alignItems: "center", gap: "0.75rem", flexWrap: "wrap" }}>
          {props.servicesTotal !== undefined && props.servicesTotal > 0 && (
            <div style={{ display: "flex", gap: "0.4rem", alignItems: "center", flexWrap: "wrap" }}>
              {props.inventoryTotal !== undefined && props.inventoryTotal > 0 && (
                <span style={{ fontSize: "0.88rem", padding: "4px 8px", background: "#f6ffed", border: "1px solid #b7eb8f", borderRadius: 6, color: "#389e0d" }}>
                  📦 Inventario: <strong>{textNumberFormater(props.inventoryTotal)}</strong>
                </span>
              )}
              <span style={{ fontSize: "0.88rem", padding: "4px 8px", background: "#f0f5ff", border: "1px solid #adc6ff", borderRadius: 6, color: "#1d39c4" }}>
                🚚 Servicios: <strong>{textNumberFormater(props.servicesTotal)}</strong>
              </span>
            </div>
          )}
          {props.subTotal !== undefined && (
            <div
              className="card shadow-sm"
              style={{
                padding: "0.6rem 1.25rem",
                borderRadius: "8px",
                backgroundColor: "#fff",
                display: "flex",
                alignItems: "center",
                gap: "0.75rem",
                border: "1px solid #e2e8f0"
              }}
            >
              <span style={{ fontSize: "1.05rem", fontWeight: 500, color: "#4a5568" }}>Subtotal:</span>
              <span className="numeric-values-data-table" style={{ fontSize: "1.3rem", fontWeight: "bold", color: "#1890ff" }}>
                {textNumberFormater(props.subTotal)}
              </span>
            </div>
          )}
        </div>
      </div>
      {register.showCreateMovement && <CreateMovementModal />}
      {register.showAddItem && <AddMovementItemModal />} 

    </div>
  )
}

export default RegisterView